import { Badge } from "@shared/ui/badge";
import { Button } from "@shared/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Tooltip, TooltipContent, TooltipTrigger } from "@shared/ui/tooltip";
import { HelpCircle, Zap } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

interface Anomaly {
  asset: string;
  anomaly: string;
  severity: "high" | "medium" | "low";
  time: string;
}

export const Anomalies: React.FC<{ data: any }> = ({ data }) => {
  const navigate = useNavigate();
  const handleInvestigate = (id: string) => {
    navigate(`/ax/service-order/landing/view/${id}`);
  };
  return (
    <Card>
      <CardHeader>
        <div className="flex item-center gap-2">
          <div>
            <CardTitle className="text-lg flex items-center gap-2">
              <Zap className="h-5 w-5" />
              Anomalies
            </CardTitle>
          </div>
          <div className="mt-1">
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <ul className="list-disc pl-5 space-y-1">
                  <li>
                    <strong>Anomaly Source :</strong> The specific asset or
                    sensor reporting an anomalous reading.
                  </li>
                  <li>
                    <strong>Anomaly Details :</strong> A description of the
                    deviation from normal operating parameters
                  </li>
                  <li>
                    <strong>Detection Time :</strong> The estimated date this
                    asset is expected to be operational again.
                  </li>
                  <li>
                    <strong>Prioritize Repair:</strong> The time that has
                    elapsed since this anomaly was first detected.
                  </li>
                </ul>
              </TooltipContent>
            </Tooltip>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3 mt-3">
          {data?.anomalies?.length ? (
            data.anomalies.map((anomaly, index) => (
              <div
                key={index}
                className="flex items-center justify-between p-3 bg-white rounded border border-orange-200"
              >
                <div>
                  <p className="font-medium">{anomaly.assetName}</p>
                  <p className="text-sm text-gray-600">{anomaly.description}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <Badge
                      variant={
                        anomaly.priority === "high"
                          ? "destructive"
                          : anomaly.priority === "medium"
                          ? "secondary"
                          : "default"
                      }
                    >
                      {anomaly.priority}
                    </Badge>
                    <span className="text-xs text-gray-500">
                      {anomaly.timeSinceDetection}
                    </span>
                  </div>
                </div>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => handleInvestigate(anomaly.serviceOrderId)}
                >
                  View
                </Button>
              </div>
            ))
          ) : (
            <p className="text-sm text-gray-500 italic text-center py-4">
              No anomalies detected.
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
